import axios from 'axios';
const myApi = axios.create({
  baseURL: '/api-v2',
});

export default {
  sendContactForm(params) {
    return myApi
      .post('/send-email-contacto',params)
      .then(response => response.data);
  },
};